"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateFilter = exports.NoCrm = void 0;
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FilterSelector_1 = require("Dashboard/FilterSelector/FilterSelector");
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var UserFilter_1 = __importDefault(require("Dashboard/FilterSelector/UserFilter/UserFilter"));
var react_1 = __importStar(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("template-filter");
exports.NoCrm = "nocrm";
var TemplateFilter = function (props) {
    var templatesWith = props.templatesWith, setTemplatesWith = props.setTemplatesWith, accountIntegrationsDataStore = props.accountIntegrationsDataStore, withCrmInfo = props.withCrmInfo, setCrmInfo = props.setCrmInfo, userList = props.userList, userFilter = props.userFilter, setUserFilter = props.setUserFilter, state = props.state, hideText = props.hideText;
    var _a = __read((0, react_1.useState)(accountIntegrationsDataStore.tokenIntegrations), 2), integrations = _a[0], setIntegrations = _a[1];
    var toggleTemplatesWith = function (blockFilterType) {
        if (templatesWith.has(blockFilterType))
            setTemplatesWith(function (prev) { return new Set(__spreadArray([], __read(prev), false).filter(function (a) { return a !== blockFilterType; })); });
        else
            setTemplatesWith(function (prev) { return new Set(prev.add(blockFilterType)); });
    };
    var hasObject = function (set, object) {
        return !!__spreadArray([], __read(set), false).find(function (item) { return item.object == object.object && item.crm == object.crm; });
    };
    var toggleCrmInfo = function (object, crm) {
        if (hasObject(withCrmInfo, { object: object, crm: crm })) {
            setCrmInfo(function (prev) { return new Set(__spreadArray([], __read(prev), false).filter(function (a) { return !(a.object === object && a.crm === crm); })); });
        }
        else {
            setCrmInfo(function (prev) { return new Set(prev.add({ object: object, crm: crm })); });
        }
    };
    var filterCount = templatesWith.size + withCrmInfo.size + userFilter.length;
    var filterText = function () {
        return "".concat(filterCount > 0 ? filterCount : "", " Filter").concat(filterCount > 1 || filterCount === 0 ? "s" : "");
    };
    (0, react_1.useEffect)(function () {
        accountIntegrationsDataStore.loadTokenIntegrationsIfNeeded().then(function () {
            setIntegrations(accountIntegrationsDataStore.tokenIntegrations);
        });
    }, []);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: c("filter_button"), type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
            react_1.default.createElement(icons_1.Filter, null),
            hideText && filterCount > 0 ? (react_1.default.createElement("span", { className: c("filter-count") },
                " ",
                filterCount)) : (!hideText && filterText()))); }, size: kaleidoscope_1.PopoverSize.Large, maxHeight: "calc(100vh - 400px)" },
        react_1.default.createElement("div", { className: c("filters") },
            react_1.default.createElement("div", { className: "space-stack-m" },
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Filters")),
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "m", long: true }, "Has content")),
                react_1.default.createElement("div", { className: c("checkbox-group") },
                    react_1.default.createElement(FilterSelector_1.CheckboxFilterRow, { text: "Accept block", checked: templatesWith.has(Types_1.TemplatesWith.AcceptBlock), onChange: function () { return toggleTemplatesWith(Types_1.TemplatesWith.AcceptBlock); } }),
                    react_1.default.createElement(FilterSelector_1.CheckboxFilterRow, { text: "Quote block", checked: templatesWith.has(Types_1.TemplatesWith.QuoteBlock), onChange: function () { return toggleTemplatesWith(Types_1.TemplatesWith.QuoteBlock); } }))),
            react_1.default.createElement("div", { className: "space-stack-m" },
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "CRM")),
                integrations.status == FetchUtils_1.RemoteDataStatus.Success ? (react_1.default.createElement(react_1.default.Fragment, null,
                    integrations.data.integrations.map(function (integration, index) { return (react_1.default.createElement("div", { key: index },
                        react_1.default.createElement(kaleidoscope_1.Label, { size: "m", long: true }, integration.displayName),
                        react_1.default.createElement("div", { className: c("checkbox-group") }, integration.supportedObjects.map(function (object, i) { return (react_1.default.createElement(FilterSelector_1.CheckboxFilterRow, { key: i, text: object, checked: hasObject(withCrmInfo, {
                                object: object,
                                crm: integration.name,
                            }), onChange: function () { return toggleCrmInfo(object, integration.name); } })); })))); }),
                    integrations.data.integrations.length > 0 && react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                    react_1.default.createElement("div", { className: c("checkbox-group") },
                        react_1.default.createElement(FilterSelector_1.CheckboxFilterRow, { text: "Non CRM", checked: hasObject(withCrmInfo, {
                                object: undefined,
                                crm: exports.NoCrm,
                            }), onChange: function () { return toggleCrmInfo(undefined, exports.NoCrm); } })))) : (react_1.default.createElement(kaleidoscope_1.Spinner, null))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "space-stack-m" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "People")),
                react_1.default.createElement(UserFilter_1.default, { userList: userList, selectedUserIds: userFilter, setSelectedUserIds: setUserFilter, "$state": state })))));
};
exports.TemplateFilter = TemplateFilter;
